import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { TourPopupLink } from '../components/TourPopupLink';
import { supabase, GuestbookEntryRow } from '../lib/supabase';
function formatDate(iso: string) {
  try {
    const d = new Date(iso);
    return d.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    }).toLowerCase();
  } catch {
    return '';
  }
}
export function Guestbook() {
  const [entries, setEntries] = useState<GuestbookEntryRow[]>([]);
  const [name, setName] = useState('');
  const [message, setMessage] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const fetchEntries = async () => {
    setIsLoading(true);
    const {
      data,
      error
    } = await supabase.from('guestbook_entries').select('*').order('created_at', {
      ascending: false
    });
    if (error) {
      setErrorMsg('could not load guestbook.');
      setEntries([]);
    } else {
      setEntries(data || []);
    }
    setIsLoading(false);
  };
  useEffect(() => {
    fetchEntries();
  }, []);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErrorMsg('');
    const trimmedMsg = message.trim();
    if (!trimmedMsg) return;
    setIsSubmitting(true);
    const trimmedName = name.trim() || 'anon';
    const {
      error
    } = await supabase.from('guestbook_entries').insert([{
      name: trimmedName,
      message: trimmedMsg
    }]);
    if (error) {
      setErrorMsg('could not save entry. try again.');
      setIsSubmitting(false);
      return;
    }
    setName('');
    setMessage('');
    setIsSubmitting(false);
    // Refresh the list so the new entry appears immediately
    await fetchEntries();
  };
  return <main className="relative min-h-screen w-full bg-[#f5f5f5] px-6 py-6 text-black md:px-10 md:py-10" style={{
    fontFamily: 'Helvetica, "Helvetica Neue", Arial, "Arial Nova", sans-serif'
  }} data-id="element-198">
      {/* Header — matches the other pages */}
      <header className="flex w-full items-start justify-between text-sm leading-tight" data-id="element-199">
        <Link to="/" className="lowercase hover:opacity-60" data-id="element-200">
          lennon cripe
        </Link>

        <nav className="flex flex-col items-start text-left" data-id="element-201">
          <Link to="/music" className="lowercase hover:opacity-60" data-id="element-202">
            catalog
          </Link>
          <TourPopupLink data-id="element-203" />
          <Link to="/shop" className="lowercase hover:opacity-60" data-id="element-204">
            shop
          </Link>
          <Link to="/guestbook" className="lowercase hover:opacity-60" data-id="element-205">
            guestbook
          </Link>
        </nav>

        <a href="mailto:info@weedwaster.com" className="lowercase hover:opacity-60" data-id="element-206">
          contact
        </a>
      </header>

      {/* Sign form */}
      <section className="mt-20 flex w-full flex-col items-start text-sm md:mt-24" data-id="element-207">
        <p className="mb-4 font-bold lowercase" data-id="element-208">sign the guestbook</p>

        <form onSubmit={handleSubmit} className="flex w-full max-w-md flex-col gap-4" data-id="element-209">
          <input type="text" value={name} onChange={e => setName(e.target.value)} placeholder="name (optional)" disabled={isSubmitting} className="border-b border-black bg-transparent py-1 text-black placeholder-black/40 focus:outline-none disabled:opacity-50" data-id="element-210" />

          <textarea value={message} onChange={e => setMessage(e.target.value)} placeholder="leave a message" rows={3} required disabled={isSubmitting} className="resize-none border-b border-black bg-transparent py-1 text-black placeholder-black/40 focus:outline-none disabled:opacity-50" data-id="element-211" />

          <button type="submit" disabled={isSubmitting} className="self-start lowercase text-black hover:opacity-60 disabled:opacity-40" data-id="element-212">
            {isSubmitting ? 'signing...' : 'sign'}
          </button>
        </form>

        {errorMsg && <p className="mt-3 lowercase text-black/50" data-id="element-213">{errorMsg}</p>}
      </section>

      {/* Entries */}
      <section className="mt-16 flex w-full flex-col items-start gap-6 text-sm md:mt-20" data-id="element-214">
        <p className="font-bold lowercase" data-id="element-215">entries</p>

        {isLoading ? <p className="lowercase text-black/50" data-id="element-216">loading...</p> : entries.length === 0 ? <p className="lowercase" data-id="element-217">no entries yet.</p> : entries.map(entry => <div key={entry.id} className="flex w-full max-w-md flex-col items-start gap-1" data-id="element-218">
              <p className="font-bold lowercase" data-id="element-219">
                {entry.name}
                <span className="ml-2 font-normal text-black/40" data-id="element-220">
                  {formatDate(entry.created_at)}
                </span>
              </p>
              <p className="lowercase" data-id="element-221">{entry.message}</p>
            </div>)}
      </section>

      <div className="h-24" data-id="element-222" />
    </main>;
}